import { Timestamp } from '@griply/types';
import { isBefore, startOfDay } from 'date-fns';

export const resolveScheduleStartDate = (
  preferred: Timestamp | null | undefined,
  today: Timestamp,
): Date => {
  if (!preferred || isBefore(startOfDay(preferred), startOfDay(today))) {
    return today;
  }
  return preferred;
};
